(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_layouts/section-odds-live/assets/javascripts/render-component.js') >= 0) return;  svs.modules.push('/components/banner_layouts/section-odds-live/assets/javascripts/render-component.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
let formatImages;
const loggerName = 'banner_layouts:section-odds-live:render-component';

async function renderComponent(model, widgetInfo, position, req, res) {
  let hbsCompiled;
  let format;
  let isAdmin;
  let helpers;
  let sportProducts;
  let bannerAccessibilityHelpers;
  let kambiConstants;
  let logger;
  const actionDescriptionId = 'match_betting_desc';
  if (svs.isServer) {
    const trinidad = require('@svenskaspelab/trinidad-core').core;
    const hbs = global.internalInstances.get('hbs');
    hbsCompiled = hbs.cache['components-banner_layouts-section_odds_live-index'];
    formatImages = trinidad.components.require('banner_common', 'banner-helpers').images.formatImages;
    format = trinidad.components.require('utils', 'format').api;
    bannerAccessibilityHelpers = trinidad.components.require('banner_common', 'banner-helpers').accessibilityHelpers;
    isAdmin = req.userSession.hasRole(req.userSession.roles.INTERNAL);
    sportProducts = trinidad.components.require('lb-utils', 'sport-products').api;
    helpers = require('./helpers.es6');
    kambiConstants = trinidad.components.require('oddset', 'kambi-offering').constants;
    logger = trinidad.logger(loggerName);
  } else {
    hbsCompiled = svs.banner_layouts.section_odds_live.templates.index;
    formatImages = svs.banner_common.banner_helpers.formatImages;
    format = svs.utils.format;
    bannerAccessibilityHelpers = svs.banner_common.banner_helpers.accessibilityHelpers;
    isAdmin = svs.core.userSession.hasRole(svs.core.userSession.roles.INTERNAL);
    sportProducts = svs.components.lbUtils.sportProducts;
    helpers = svs.banner_layouts.section_odds_live.helpers;
    kambiConstants = svs.components.oddset.kambiOffering.common.constants;
    logger = svs.core.log.getLogger(loggerName);
  }
  try {
    var _model$contentType, _liveData$matchClock;
    const {
      BetOfferType,
      EventState,
      resolveBetOffer,
      resolveCube,
      resolveLiveData,
      getMatchMinuteFromMatchClock
    } = helpers;
    const {
      eventConnected,
      id: bannerId,
      images: modelImages,
      layoutConfig,
      layoutType,
      title,
      targetOffer
    } = model;
    const {
      cube,
      slim = false,
      tab = null
    } = layoutConfig || {};
    const images = (modelImages === null || modelImages === void 0 ? void 0 : modelImages.length) && formatImages(model, 'typeName');
    const contentType = (model === null || model === void 0 || (_model$contentType = model.contentType) === null || _model$contentType === void 0 ? void 0 : _model$contentType.split(':').pop()) || 'banner';
    const crm = targetOffer || '';
    const isFullWidth = true;
    const trackingStringTitle = format.safeString(title) || title;
    const trackingString = "".concat(widgetInfo.widgetType, "/").concat(widgetInfo.trackingId, "/").concat(position, "/").concat(layoutType, "/").concat(trackingStringTitle);
    const betOfferTypes = [BetOfferType.ONE_X_TWO, BetOfferType.HEAD_TO_HEAD, BetOfferType.YES_NO];
    const {
      event,
      eyebrow,
      betActions,
      eventCta,
      eventUrl,
      outcomes
    } = await resolveBetOffer(eventConnected === null || eventConnected === void 0 ? void 0 : eventConnected.eventId, betOfferTypes, isAdmin);
    const isLive = (event === null || event === void 0 ? void 0 : event.state) === EventState.STARTED;
    if (svs.isServer) {
      var _model$layoutConfig$e, _model$layoutConfig;
      res.addModels([{
        category: 'banner_layouts',
        objectName: 'section_odds_live',
        name: 'bannerModel',
        model: {
          bannerTitle: (_model$layoutConfig$e = (_model$layoutConfig = model.layoutConfig) === null || _model$layoutConfig === void 0 ? void 0 : _model$layoutConfig.eyebrow) !== null && _model$layoutConfig$e !== void 0 ? _model$layoutConfig$e : event.group,
          actionDescriptionId,
          trackingString,
          callToActions: model.callToActions,
          eventUrl,
          event,
          eventId: Number(eventConnected === null || eventConnected === void 0 ? void 0 : eventConnected.eventId),
          isLive,
          outcomes
        }
      }]);
    }
    const callToActions = helpers.normalizeCta(betActions, actionDescriptionId, model.callToActions);
    const liveData = await resolveLiveData(eventConnected === null || eventConnected === void 0 ? void 0 : eventConnected.eventId, isAdmin);
    const {
      home = 0,
      away = 0
    } = (liveData === null || liveData === void 0 ? void 0 : liveData.score) || {};
    const matchClock = (_liveData$matchClock = liveData === null || liveData === void 0 ? void 0 : liveData.matchClock) !== null && _liveData$matchClock !== void 0 ? _liveData$matchClock : {
      minute: 0,
      second: 0,
      periodId: kambiConstants.PeriodId.UNKNOWN
    };
    const liveTime = getMatchMinuteFromMatchClock(matchClock);
    return hbsCompiled(_objectSpread(_objectSpread({}, layoutConfig), {}, {
      loading: true,
      event,
      bannerTitle: (layoutConfig === null || layoutConfig === void 0 ? void 0 : layoutConfig.eyebrow) || eyebrow.group,
      bannerBody: layoutConfig.body,
      startTimeString: eyebrow.time,
      liveTime,
      callToActions,
      eventUrl,
      classes: 'hero-odds-live',
      crm,
      useH2: layoutConfig === null || layoutConfig === void 0 ? void 0 : layoutConfig.useH2,
      dataset: {
        cmsid: bannerId,
        cmstype: contentType,
        eventId: eventConnected === null || eventConnected === void 0 ? void 0 : eventConnected.eventId,
        impression: true,
        'impression-tracking': trackingString,
        type: layoutType
      },
      eventCta,
      isLive,
      score: {
        home,
        away
      },
      roleDescription: bannerAccessibilityHelpers.ariaRoleDescription(tab, layoutConfig),
      cube: cube ? resolveCube(sportProducts.productIds.ODDSET) : null,
      image: images === null || images === void 0 ? void 0 : images.backgroundImage,
      isAdmin,
      isBetActions: Boolean(betActions.length),
      actionDescriptionId,
      isFullWidth,
      slim,
      tab,
      trackingString
    })) || '';
  } catch (error) {
    logger.warn('Error while rendering component: ', error.toString());
    return '';
  }
}
if (svs.isServer) {
  module.exports = {
    renderComponent
  };
} else {
  setGlobal('svs.banner_layouts.section_odds_live', {
    renderComponent
  });
}

 })(window);